<template>
  <form
    autocomplete="off"
    class="form-price form-price__form"
    v-on:submit.prevent="onSubmit">
    <input-text
      required="required"
      title="Название прайса"
      v-bind:violations="nameErrors"
      v-model="name"
      v-letter-capital
      maxlength="50"
    />
    <div class="form-price__form__buttons">
      <button
        class="form-price__form__button-cancel"
        type="button"
        v-on:click.prevent="close">
        Отмена
      </button>
      <button type="submit" class="form-price__form__button-save">
        Сохранить
      </button>
    </div>
  </form>
</template>

<script>
import InputText from '@/components/InputText.vue';
import formMeaningfulFieldsMixin from '@/mixins/formMeaningfulFieldsMixin';

/**
 * @description Обновить прайс-лист.
 * @type {string}
 */
const ON_EDIT_SERVICE_PRICE_LIST = 'on-edit-price-list';

/**
 * @description Создать прайс-лист.
 * @type {string}
 */
const ON_CREATE_SERVICE_PRICE_LIST = 'on-create-price-list';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.inputErrors ? vm.inputErrors[cause] : []
);
export default {
  name: 'FormPrice',
  components: {
    InputText,
  },
  computed: {
    nameErrors: resolveInputErrors('input_name'),
    /**
     * @description Значимые поля.
     * @type {any}
     */
    meaningfulFields: (vm) => ({
      name: vm.name,
    }),

    /**
     * @description Редактируем ли.
     * @type {boolean}
     */
    isServicePriceListEdit() {
      return this.initialServicePriceList !== null;
    },
  },
  methods: {
    /**
     * @description Закрыть форму.
     * @returns {void}
     */
    close() {
      this.$emit('close');
    },
    /**
     * @description Обработать отправку формы.
     * @returns {void}
     */
    onSubmit() {
      const request = {
        id: this.id,
        name: this.name,
      };
      if (this.isServicePriceListEdit) {
        this.$emit(ON_EDIT_SERVICE_PRICE_LIST, request);
      } else {
        this.$emit(ON_CREATE_SERVICE_PRICE_LIST, request);
      }
    },
  },
  data() {
    return {
      /**
       * @description Id Прайс-листа.
       * @type {string}
       */
      id: this.initialServicePriceList?.val?.id ?? '',
      /**
       * @description Имя прайса
       * @type {string}
       */
      name: this.initialServicePriceList?.val?.name ?? '',
    };
  },
  mixins: [formMeaningfulFieldsMixin],
  props: {
    /**
     * @description Нарушения ограничений.
     * @type {any}
     */
    inputErrors: {
      type: Object,
      required: true,
    },
    /**
     * @description Начальные данные
     * @type {Object}
     */
    initialServicePriceList: {
      type: Object,
      required: false,
      default: () => null,
    },
  },
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";
.form-price {
  position: relative;
  &__caption {
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
  }
  &__exit {
    position: absolute;
    right: -15px;
    top: 0px;
    background-image: url("@/assets/img/exit-black.svg");
    background-position: center;
    background-size: auto;
    background-repeat: no-repeat;
    background-color: #eaeff3;
    padding: 9px;
    border-radius: 2px;
    width: 32px;
    height: 32px;
    cursor: pointer;
    &:hover {
      background-color: transparent;
    }
  }
  &__form {
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 20px;
    margin: 20px 0 0 0;
    &__group {
      display: flex;
      flex-direction: column;
      gap: 10px;
      &.field_error {
        .form-price__form__label {
          color: var(--warning-color);
        }
      }
    }
    &__label {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: #90a0b7;
      margin: 0 0 2px 0;
    }
    &__input {
      background: #ffffff;
      border: 1px solid #c2cfe0;
      border-radius: 4px;
      outline: none;
      height: 40px;
      width: 100%;
      padding: 0 10px;
      appearance: none;
      font-size: 16px;
      color: #192a3e;
      font-weight: 400;
      &:focus {
        color: #192a3e;
        background-color: #fff;
        border: 2px solid #0489e0;
        outline: 0;
      }
      &:disabled {
        background-color: #fff;
      }
    }
    &__select {
      background-color: #ffffff;
      background-image: url("@/assets/img/checked/checked-grey.svg");
      background-position: right 17px center;
      border: 1px solid #c2cfe0;
      border-radius: 4px;
      outline: none;
      height: 40px;
      padding: 0 10px;
      appearance: none;
      font-size: 16px;
      color: #192a3e;
      font-weight: 400;
      &:focus {
        color: #192a3e;
        background-color: #fff;
        border: 2px solid #0489e0;
        outline: 0;
        background-image: url("@/assets/img/checked/checked-grey-top.svg");
      }
      &:disabled {
        background-color: #fff;
        background-image: url("@/assets/img/checked/checked-grey.svg");
      }
    }
    &__buttons {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 10px;
      max-width: 438px;
      width: 100%;
      margin: 30px 0 0 auto;
    }
    &__button {
      &-cancel {
        @include buttons.btn-transparent(100%, 56px, 20px);
      }
      &-save {
        @include buttons.btn-blue(100%, 56px, 20px);
      }
    }
    &__error-text {
      color: var(--warning-color);
      font-size: 12px;
      line-height: 12px;
      padding: 0;
      margin: 0;
    }
  }
}
</style>
